import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {observable, computed} from "mobx";
import {SBAPages} from "../../screens/FormSBA/FormSBASteps/SBATypes";
import {ISBALoanSetStateRequest} from "shared/functions/membersApi/types/ISignupProcess";
import FirebaseSignUpService from "src/services/firebase/functions/FirebaseSignUpService";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import { FINANCE_TEXTS } from "../../screens/FormSBA/SBAFormTexts";

const INITIAL_SCREEN = SBAPages.business;


export class SbaLoanStore extends ApiCallObservable {
    @observable public formInput: any = {
        documentation: {}
    };
    @observable public navigationController = {};
    @observable public currentPage: SBAPages = INITIAL_SCREEN;
    public needToInitUIPage: boolean = false
    private cowork: string;
    private ownershipsArr:any = [];
    private uid: string;
    private routingNumber: string;
    private possibleBankName: string;
    private afterFollowUpLink: boolean;

    public setApp(id: string, cowork: string) {
        this.uid = id;
        this.cowork = cowork
        this.currentPage = SBAPages.documentation
        this.needToInitUIPage = true
        this.afterFollowUpLink = true
    }

    @computed
    get isAfterFollowUpLink() {
        return this. afterFollowUpLink
    }

    public saveOwnership = () => {
        this.ownershipsArr.push(this.formInput.ownership);
    };

    public getOwnershipArray = () => {
        return this.ownershipsArr;
    }

    public restoreLastUser = () => {
        this.formInput.ownership = this.ownershipsArr[this.ownershipsArr.length - 1];
        this.formInput.ownership.anotherOwnership = "";
        this.ownershipsArr.pop();
    };

    public updateCurrentScreen = (newScreen: SBAPages) => {
        this.currentPage = newScreen;
        if(newScreen === SBAPages.finance) {
            if(this.formInput.loanCalculator.maximumLoan && isNaN(this.formInput.loanCalculator.maximumLoan)) {
                this.formInput[SBAPages.finance].loanAmount = this.formInput.loanCalculator.maximumLoan;
            }
        }
    }

    public async submit() {
        try {

            this.setSending();
            const data = this.prepareDataToSend()
            const response = await FirebaseSignUpService.createSBALoanApplication(data);

            if (response.ok) {
                this.uid = response.data
                this.setSuccessfulResponse(response.data);
            } else {
                this.setError(response.error && response.error!.message ? response.error!.message! : "Unknown Error");

            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
        return true;
    }

    public uploadFirstPdf = async (data: any, name: string) => {
        const payload = {
            files: {
                uid : this.uid,
                cowork: this.cowork,
                firstPdfFile: data,
                name
            }
        }
        try {
            this.setSending();
            this.formInput.documentation.sbaFirstPdfFile = "sending";
            const response = await FirebaseSignUpService.createSBALoanApplication(payload);
            if (response.ok) {
                this.setSuccessfulResponse({});
                this.formInput.documentation.sbaFirstPdfFile = data;
            } else {
                this.formInput.documentation.sbaFirstPdfFile = false;
                this.setError(response.error && response.error!.message ? response.error!.message! : "Unknown Error");
            }
        } catch (err) {
            this.formInput.documentation.sbaFirstPdfFile = false;
            console.error(err);
            this.setError(`${err}`);
        }
    }

    public uploadSecondPdf = async (data: any, name:string) => {
        const payload = {
            files: {
                uid : this.uid,
                cowork: this.cowork,
                secondPdfFile: data,
                name
            }
        }
        try {
            this.setSending();
            this.formInput.documentation.sbaSecondPdfFile = "sending";
            const response = await FirebaseSignUpService.createSBALoanApplication(payload);
            if (response.ok) {
                this.setSuccessfulResponse({});
                this.formInput.documentation.sbaSecondPdfFile = data;
            } else {
                this.formInput.documentation.sbaSecondPdfFile = false;
                this.setError(response.error && response.error!.message ? response.error!.message! : "Unknown Error");
            }
        } catch (err) {
            this.formInput.documentation.sbaSecondPdfFile = false;
            console.error(err);
            this.setError(`${err}`);
        }
    }

    public uploadThirdPdf = async (data: any, name: string) => {
        const payload = {
            files: {
                uid : this.uid,
                cowork: this.cowork,
                thirdPdfFile: data,
                name
            }
        }
        try {
            this.formInput.documentation.sbaThirdPdfFile = "sending";
            this.setSending();
            const response = await FirebaseSignUpService.createSBALoanApplication(payload);

            if (response.ok) {
                this.setSuccessfulResponse({});
                this.formInput.documentation.sbaThirdPdfFile = data;
            } else {
                this.formInput.documentation.sbaThirdPdfFile = false;
                this.setError(response.error && response.error!.message ? response.error!.message! : "Unknown Error");
            }
        } catch (err) {
            this.formInput.documentation.sbaThirdPdfFile = false;
            console.error(err);
            this.setError(`${err}`);
        }
    }

    public reCalculateLoan = () => {
        const annualPayrollCostsParams = ["wages", "tips", "vacation", "allowance", "benefits", "taxes"];
        this.formInput.loanCalculator.annualPayroll = 0;
        this.formInput.loanCalculator.adjustPayroll = 0;
        this.formInput.loanCalculator.averageMonthlyQualifyingPayroll = 0;
        this.formInput.loanCalculator.multipleMonths = 0;
        this.formInput.loanCalculator.maximumLoan = 0;
        Object.entries(this.formInput.loanCalculator).forEach(([key]) => {
            if(annualPayrollCostsParams.includes(key)) {
                this.formInput.loanCalculator.annualPayroll += parseInt(this.formInput.loanCalculator[key], 10) || 0;
            }
            this.formInput.loanCalculator.adjustPayroll = this.formInput.loanCalculator.annualPayroll - (parseInt(this.formInput.loanCalculator.individualPayrollCosts, 10) || 0);
            if(this.formInput.loanCalculator.adjustPayroll < 0) {
                this.formInput.loanCalculator.adjustPayroll = 0
            }
            this.formInput.loanCalculator.averageMonthlyQualifyingPayroll = (this.formInput.loanCalculator.adjustPayroll / 12).toFixed(2);
            if(this.formInput.loanCalculator.averageMonthlyQualifyingPayroll < 0) {
                this.formInput.loanCalculator.averageMonthlyQualifyingPayroll = 0
            }
            this.formInput.loanCalculator.multipleMonths = (
                (parseInt(this.formInput.loanCalculator.averageMonthlyQualifyingPayroll,10) || 0) * 2.5).toFixed(2);
            if(this.formInput.loanCalculator.multipleMonths < 0) {
                this.formInput.loanCalculator.multipleMonths = 0
            }
            this.formInput.loanCalculator.maximumLoan = ((parseInt(this.formInput.loanCalculator.multipleMonths,10) || 0)
            + (parseInt(this.formInput.loanCalculator.outstandingBalanceEIDL,10) || 0)
            - (parseInt(this.formInput.loanCalculator.EIDLAdvance, 10 || 0))).toFixed(2);
            if(this.formInput.loanCalculator.maximumLoan < 0 || isNaN(this.formInput.loanCalculator.maximumLoan)) {
                this.formInput.loanCalculator.maximumLoan = 0
            }
        });
    }

    public setSearchLocationResult(propertyName : string, val: IGooglePlace | string, formPageName: SBAPages) {
        // tslint:disable-next-line: prefer-conditional-expression
        if ((val as IGooglePlace).formattedAddress) {
            this.formInput[formPageName][propertyName] = (val as IGooglePlace).formattedAddress
        } else {
            this.formInput[formPageName][propertyName] = val
        }
    }

    public async fetchBankName() {
        try {
            const routingNumber = this.routingNumber
            this.setSending();
            const response = await FirebaseSignUpService.getBankNameFromRoutingNumber({routingNumber});

            if (response.ok) {
                this.setSuccessfulResponse(response.data)
                this.formInput[SBAPages.finance][FINANCE_TEXTS.PROP_NAMES.BANK_NAME] = response.data.bankName
            } else {
                this.setError(response.error!.message!)
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
        return true;
    }

    @computed
    get bankRoutingNumber() {
        return this.routingNumber;
    }
    set bankRoutingNumber(number: string) {
        this.routingNumber = number;
    }

    @computed
    get bankName() {
        return this.possibleBankName;
    }
    set bankName(name: string) {
        this.possibleBankName = name;
    }

     
    public getAcceptedFilesToUpload()  {
        return "" // Allow all types
    }

    private prepareDataToSend() {
        const { employeesAmount, fullName, emailAddress, businessType, BusinessName, DBA, TIN, BusinessPhone, BusinessAddress } = this.formInput[SBAPages.business];
        const { loanAmount, bankName, routingNumber, accountNumber, accountOwnerName} = this.formInput[SBAPages.finance];
        const { q1, q2, q3, q4, q5, q6, q7, q8, bankEmailAddress } = this.formInput[SBAPages.general];
        const ownerships = this.ownershipsArr.map((item: { ownerName: any; ownerTitle: any; ownerPercentage: any; ownerTin: any; ownerAddress: any; }) => {
            return ({
                name : item.ownerName,
                title : item.ownerTitle,
                ownership : item.ownerPercentage,
                tin: item.ownerTin,
                address: item.ownerAddress
            })
        })

        const requestData : ISBALoanSetStateRequest = {
            application: {
                businessInfo: {
                    name: fullName,
                    emailAddress,
                    businessName: BusinessName,
                    businessType,
                    dba: DBA,
                    businessTin: TIN,
                    businessPhone: BusinessPhone,
                    businessAddress: BusinessAddress,
                    numOfEmployees: employeesAmount,
                },
                financialInfo: {
                    loanRequest : loanAmount,
                    averageMonthlyPayroll : this.formInput.loanCalculator.averageMonthlyQualifyingPayroll,
                    bankName,
                    routingNumber,
                    accountNumber,
                    accountOwnerName,
                    ...this.prepareLoanPurposes()
                },
                ownerships,
                answers: {
                    q1,
                    q2,
                    q3,
                    q4,
                    q5,
                    q6,
                    q7,
                    q8,
                    bankEmailAddress
                }
            }
        }
        return requestData
    }

    private prepareLoanPurposes() {
        const { loanPurpose } = this.formInput[SBAPages.finance]
        const purposes = loanPurpose as string[]
        const lastElement = purposes.pop()!
        if (lastElement.startsWith("Other:")){
            purposes.push("Other")
            const otherLoanPurpose = lastElement.split("Other:")[1]

            return {loanPurpose, otherLoanPurpose}
        } else {
            purposes.push(lastElement!)
            return {loanPurpose: purposes, otherLoanPurpose: ""}
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/SbaLoanStore.ts